const Vote = {
    LOVED:"LOVED",
    LIKED:"LIKED",
    DISLIKED:"DISLIKED",
    NEUTRAL:"NEUTRAL"
};

export default Object.freeze(Vote);